export const FETCH_ORDER_SUCCESS = 'FETCH_ORDER_SUCCESS';
export const FETCH_ORDER_REQUEST = 'FETCH_ORDER_REQUEST';
export const FETCH_ORDER_FAILURE = 'FETCH_ORDER_FAILURE';
export const FETCH_ORDER_REST = 'FETCH_ORDER_REST';
export const fetchOrderSuccess = (payload) => ({
    type: FETCH_ORDER_SUCCESS,
    payload,
});
export const fetchOrderRequest = (payload) => ({
    type: FETCH_ORDER_REQUEST,
    payload,
});
export const fetchOrderFailure = (payload) => ({
    type: FETCH_ORDER_FAILURE,
    payload,
});
export const fetchOrderReset = () => ({
    type: FETCH_ORDER_REST,
});
